// This comp is loaded via App.js, appears on every page. Better than prev method, where it was loaded and called in each comp

import { useEffect } from 'react';
import { useLocation } from 'react-router';

const RedirectToHttps = () => {
   let location = useLocation();
   useEffect(() => {
      if (window.location.protocol !== 'https:') {
         window.location.replace(
            'https://mybooksx.herokuapp.com' + location.pathname
         );
      }
   }, []);

   return null;
};

export default RedirectToHttps;
